// Presentation only: never use the public identity as a lookup key.
export function customerDeviceIdentity(device) {
  const value=typeof device==='string'?device:device?.profile?.identifier||device?.id||device?.deviceId;
  return typeof value==='string'?value.replace(/^gt06-/i,''):null;
}

export function qualityBatteryLabel(summary,locale='da-DK') {
  const da=locale==='da-DK',valid=value=>typeof value==='number'&&Number.isFinite(value);
  if(valid(summary?.batteryStartPercent)&&valid(summary?.batteryEndPercent))
    return `${summary.batteryStartPercent} % → ${summary.batteryEndPercent} %`;
  if(valid(summary?.batteryStartLevel)&&valid(summary?.batteryEndLevel))
    return `${da?'Niveau':'Level'} ${summary.batteryStartLevel}/6 → ${summary.batteryEndLevel}/6`;
  return da?'Ikke nok batteridata i perioden.':'Not enough battery data in this period.';
}

// Categorical readings during charging are not proof of a full battery.
export function chargingLevelUncertain(status) {
  return status?.charging===true&&status?.batteryLevel===6;
}
